import type { EventFilter } from "@/Modules/Chat/WebSocketManager";
import { MessageTypeWebSocket, type UserStatusMessageWebSocket } from "@/Modules/Chat/Models/WebSocket";
import type { ChatUserStatus } from "../Models/Domain/Chat";

import { type ChatStore, useChatStore } from "@/Modules/Chat/Store";
import UserStateWebSocketToUserState from "@/Modules/Transformers/Chat/UserStatusWebSocketToUserStatus";

import { isObject } from "@/Utils/Objects";
import { unixUTC } from "@/Utils/Date";
import { isValidString } from "@/Utils/String";

export interface ExtraParamsUpdateUserStatus {
  chatStore: ChatStore;
}

export const isUserStatusType = (message: unknown) => {
  return isObject(message) && message.type === MessageTypeWebSocket.STATUS && isValidString(message.status);
};

export const UserStatusHandler = (
  message: UserStatusMessageWebSocket,
  { chatStore = useChatStore() }: ExtraParamsUpdateUserStatus
): Promise<ChatUserStatus | undefined> => {
  const status = UserStateWebSocketToUserState(message.status);
  const lastConnection = unixUTC() - message.active;

  const chatId = Object.keys(chatStore.rooms).find((cid) => {
    return chatStore.rooms[cid].user.id === message.user;
  });

  if (chatId !== undefined) {
    chatStore.rooms[chatId].user.status = status;
    chatStore.rooms[chatId].user.lastConnection = lastConnection;
  }

  return Promise.resolve(status);
};

export default {
  isType: isUserStatusType,
  handler: UserStatusHandler,
} as EventFilter<ExtraParamsUpdateUserStatus>;
